import React, { useEffect } from 'react'
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import { Col, Container, Row } from 'react-bootstrap';
import ImageCard from '../../../Components/ImageCard/ImageCard';
import CenterStage from '../../../Components/CenterStage/CenterStage';
import ServiceCarousel from '../../../Components/ServiceCarousel/ServiceCarousel';
import imgStage from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/stage.jpg'
import imgDonationInsteadGift from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/DonationInsteadGift.jpg'
import imgFoundation from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/HFFoundation.jpg'
import imgWeAreCommitted from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/WeAreCommitted.jpg'
import imgStudentRacing from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/StudentRacing.jpg'
import imgSumatra from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/Sumatra.jpg'
import imgOldAndYoung from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/OldAndYoung.jpg'
import imgOffRoad from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/OffRoad.jpg'
import imgValueBasedCooperation from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/ValueBasedCooperation.jpg'
import imgDonation from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/Donation.jpg'
import imgBecomeAPart from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/BecomeAPart.jpg'

const ResponsibilityAndSocialCommitments = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const data1 = {
        image: imgDonationInsteadGift,
        title: 'Donations instead of gifts',
        description: 'As part of our Christmas campaign “Donations instead of gifts”, we have been distributing a mid-five-figure amount each year to three selected aid organisations since 2017. The donations go towards current projects for the sustainable improvement of drinking water and sanitation for people in the southern hemisphere. Reporting in our customer and employee magazine Hydraulikpresse, our campaign website and directly addressing customers and business partners allows us to increase awareness of the organisations and their projects, encouraging additional donations.',
    }

    const data2 = {
        image: imgFoundation,
        title: 'The HANSA-FLEX Foundation',
        description: 'The HANSA-FLEX Foundation was established in 2012 by company founder Joachim Armerding. It is committed to the education and promotion of the youth as well as intercultural exchange in addition to heralding Bremen as a location for science, research and further studies. The HANSA-FLEX Foundation is a member of university sponsorship and support groups, supports scholarship holders and maintains endowed professorships at various faculties while facilitating a wide range of cultural and educational projects and local initiatives.',
    }

    const data3 = {
        image: imgWeAreCommitted,
        title: 'We are committed to people on the move',
        description: "Sports promote health and well-being and strengthen cohesion. That is why HANSA-FLEX supports clubs, teams and athletes at many locations. The international HANSA-FLEX club sponsorship is our largest regular activity for the youth sector. Since 2002, we have equipped a total of 30 children’s and youth teams with new sportswear every year. The high-quality team equipment, worth 1,000 euros each, benefits teams from a wide range of sports at home and abroad. For our 60th anniversary, in 2022, we will sponsor 60 youth teams instead of 30.",
    }

    const ServiceCarouselData = [
        {
            title: "Student racing team",
            description: "HANSA-FLEX is one of the sponsors of Deefholt Dynamics e.V. The multidisciplinary team of students from the Private University of Applied Sciences (PHWT) in Diepholz regularly takes part in the major international Formula Student design competitions.",
            imageSrc: imgStudentRacing
        },
        {
            title: "Assisting with reconstruction in Sumatra",
            description: "The village of Suak Nie in the province of Aceh in the north of the island of Sumatra was hit particularly hard by a tsunami disaster in Southeast Asia in the early 2000s. Since then, HANSA-FLEX has been supporting villagers with the sustainable development of new livelihoods in cooperation with terre des hommes.",
            imageSrc: imgSumatra
        },
        {
            title: "Old- and young-timer meeting",
            description: "The HANSA-FLEX Motor Classic is a special kind of team event. In late summer, young- and old-timer fans from our collegial circle meet for an exhilarating motor sports weekend. This classic car rally takes place at various locations in quaint agricultural surroundings.",
            imageSrc: imgOldAndYoung
        },
        {
            title: "International off-road adventure",
            description: "Under the name XWORLD, HANSA-FLEX has organised three extraordinary off-road adventure tours through Europe/Asia, South America and Africa, with participants crossing a total of 58 countries and covering more than 150,000 kilometres.",
            imageSrc: imgOffRoad
        }
    ];

    return (
        <div>
            <CenterStage imageSrc={imgStage}
                title={"WE KNOW WHERE OUR RESPONSIBILITIES LIE"}
                paragraph={"For HANSA-FLEX as an owner-managed family company, social commitment to people and society has always been a fundamental principle. In addition to supporting charitable organisations and projects, the company also promotes sport, education and intercultural dialogue."} />

            <SectionHeader title={"COMMITMENT TO PEOPLE AND THEIR NEEDS"} />
            <ImageText data={data1} left={true} />
            <ImageText data={data2} left={false} />
            <ImageText data={data3} left={true} />

            <SectionHeader title={"WE STRENGTHEN COMMUNITIES AND FOSTER PASSION"}
                subtitle={"HANSA-FLEX is committed to helping and connecting people, strengthening communities and supporting passionate work in many locations."} />
            <ServiceCarousel images={ServiceCarouselData} autoPlayInterval={5000} />

            <SectionHeader
                title={"FIND OUT MORE ABOUT THE HANSA-FLEX’S CULTURE AND VALUES"}
            />
            <div>
                <Container className="custom-container">
                    <Row>
                        <Col sm={12} md={6} lg={4} ><ImageCard image={imgValueBasedCooperation}
                            title="Value-based cooperation"
                            desc={"HANSA-FLEX stands for fairness, respect and transparency. Our Mission Statement and Code of Conduct apply at all locations worldwide."}
                            learnMoreLink={"/hf-group-mission-statement"} /></Col>

                        <Col sm={12} md={6} lg={4} ><ImageCard image={imgDonation}
                            title="Donations instead of gifts"
                            desc={"Get to know all the projects we have supported since 2017 as part of our annual Christmas campaign."}
                            learnMoreLink={"/donation-instead-gifts"} /></Col>

                        <Col sm={12} md={6} lg={4} ><ImageCard image={imgBecomeAPart}
                            title="Become part of the team"
                            desc={"We are looking for new colleagues with a passion for their work and great expertise in their fields for various commercial and technical positions at several locations."}
                            learnMoreLink={"/careers"} /></Col>
                    </Row>
                </Container>
            </div>

        </div>
    )
}

export default ResponsibilityAndSocialCommitments   